<template>
  <v-app id="inspire">
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center" v-show="error">
        <v-col cols="12" sm="10" md="6">
          <v-alert type="error" border="left">{{ error }}</v-alert>
        </v-col>
      </v-row>
      <v-row align="center" justify="center" v-show="message">
        <v-col cols="12" sm="10" md="6">
          <v-alert type="success" border="left">{{ message }}</v-alert>
        </v-col>
      </v-row>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <base-material-card icon="mdi-lock-open" color="cyan" :title="$i18n.t('Reset Password')">
            <v-form>
              <v-container class="py-0">
                <v-row>
                  <v-col cols="12" md="4">
                    <z-country-select
                      preIcon="mdi-earth"
                      v-model="user.countryCode"
                      :label="$i18n.t('Code')"
                      isd
                      hideName
                      hideFlag
                    />
                  </v-col>
                  <v-col cols="12" md="8">
                    <v-text-field
                      :label="$i18n.t('Email/Phone')"
                      name="login"
                      prepend-icon="person"
                      type="text"
                      v-model="user.emailPhone"
                    />
                  </v-col>
                  <v-col cols="12" md="12">
                    <v-row>
                      <img :src="captchaSrc" style="height:36px; float:left" class="px-3" />
                      <v-btn
                        @click="handleRefreshCaptchaFloatQuery"
                        text
                        fab
                        x-small
                        style="float:right"
                      >
                        <v-icon>mdi-reload</v-icon>
                      </v-btn>
                    </v-row>
                  </v-col>
                  <v-col cols="12" md="12">
                    <v-text-field
                      :label="$i18n.t('Enter Captcha Value')"
                      prepend-icon="lock"
                      v-model="user.captchaQuery"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <v-btn text color="info" to="/login">
                      <span style="color:black">{{$i18n.t('Have Password?')}} &nbsp;</span>
                      <span>&nbsp; {{$i18n.t(" Login Here") }}</span>
                    </v-btn>
                  </v-col>
                  <v-col cols="6" class="text-right">
                    <v-btn
                      color="primary"
                      @click="resetPass"
                      :loading="loading"
                    >{{ $i18n.t("Reset Password") }}</v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </base-material-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import common from "@/store/common/module/common";
import { doPost } from "../../store/common/module/apis";
import auth from "@/store/user/module/auth";

@Component
export default class Login extends Vue {
  user = { countryCode: 91, emailPhone: "", captchaQuery: "" };
  captchaSrc = null;

  get loading() {
    return common.loading;
  }

  get error() {
    return common.error;
  }

  get message() {
    return common.message;
  }

  async beforeMount() {
    try {
      await auth.doPreLogin();
    } catch (e) {
      console.log(e);
      this.captchaSrc =
        "/api/o/captcha/forgetPassword?id=" + new Date().getTime();
    }
  }

  mounted() {
    if (auth.authContent) {
      this.user.countryCode = auth.authContent.countryCode;
    }
  }

  async handleRefreshCaptchaFloatQuery() {
    common.showMessage();
    common.setError();
    this.captchaSrc =
      "/api/o/captcha/forgetPassword?id=" + new Date().getTime();
  }

  processEmailPhone() {
    if (this.user.emailPhone) {
      if (isNaN(parseInt(this.user.emailPhone))) {
        this.user.email = this.user.emailPhone;
        this.user.phone = null;
      } else {
        this.user.phone = parseInt(this.user.emailPhone);
        this.user.email = null;
        if (this.user.countryCode == null) {
          common.setError("Please provide country code");
          return false;
        }
      }
      return true;
    }
    common.setError("Please enter email/phone");
    return false;
  }

  async resetPass() {
    if (!this.processEmailPhone()) return;
    common.setLoading(true);
    try {
      await doPost("/api/o/supervisor/password/reset", this.user);
      common.setLoading(false);
      common.setError();
      common.showMessage("Your new password has been sent to Email/Phone");
    } catch (e) {
      common.showMessage();
      common.setError(e.message);
      common.setLoading(false);
    }
  }

  onDismissed() {
    //this.$store.dispatch("clearError");
  }
}
</script>
